import { CloudUploadOutlined } from '@ant-design/icons';
import { Button, Progress, Skeleton, Typography } from 'antd';

import { generateKey } from '@app/utils';

import { useImportFromExcel } from '@pages/Clients/ImportFromExcel/hooks/useImportFromExcel';

import { ImportErrorItem } from '@pages/Clients/ImportFromExcel/components/ImportErrorItem';

import '@pages/Clients/ImportFromExcel/styles/ImportFromExcel.desktop.scss';

const { Text } = Typography;

export const ImportFromExcel = () => {
  const {
    progress,
    countCreate,
    countUpdate,
    errors,
    isClientsPage,
    isEmployeesPage,
    isServicesPage,
    isRecordsPage,
    isProductsPage,
    hasImport,
    isStopImportClientsExcelLoading,
    stopClientsImport,
    isStopImportRecordsExcelLoading,
    stopRecordsImport,
    isStopImportServicesExcelLoading,
    stopServicesImport,
    isStopImportEmployeesExcelLoading,
    stopEmployeesImport,
    isStopImportProductsExcelLoading,
    stopProductsImport,
  } = useImportFromExcel();

  const stopImport = isRecordsPage
    ? stopRecordsImport
    : isServicesPage
    ? stopServicesImport
    : isEmployeesPage
    ? stopEmployeesImport
    : isProductsPage
    ? stopProductsImport
    : stopClientsImport;

  const isStopImportLoading = isRecordsPage
    ? isStopImportRecordsExcelLoading
    : isServicesPage
    ? isStopImportServicesExcelLoading
    : isEmployeesPage
    ? isStopImportEmployeesExcelLoading
    : isProductsPage
    ? isStopImportProductsExcelLoading
    : isStopImportClientsExcelLoading;

  const uploadStatus = progress === 100 ? 'завершён' : 'в процессе';
  let title = '';

  if (isClientsPage) {
    title = 'клиентов';
  }

  if (isEmployeesPage) {
    title = 'исполнителей';
  }

  if (isServicesPage) {
    title = 'услуг';
  }

  if (isRecordsPage) {
    title = 'записей';
  }

  if (isProductsPage) {
    title = 'товаров';
  }

  if (!hasImport) {
    return <Skeleton />;
  }

  return (
    <div className="excel-window_wrapper">
      <div className="excel-window_container">
        <div className="upload-success">
          <Progress
            percent={progress}
            percentPosition={{ align: 'end', type: 'inner' }}
            size={[600, 20]}
            strokeColor="#001342"
            style={{ marginBottom: '20px' }}
          />
          <Typography.Title level={4} data-testid="import-complete-title">
            <CloudUploadOutlined style={{ color: 'rgb(22, 119, 255)' }} />{' '}
            {`Импорт ${title} из файла ${uploadStatus}`}
          </Typography.Title>

          <div className="info-panel">
            <div className="info-item green">
              <Text strong data-testid="added-title">
                Добавлено
              </Text>
              <div
                style={{
                  color: '#52c41a',
                  fontWeight: '600',
                  fontSize: '24px',
                }}
                data-testid="added-count"
              >
                {countCreate}
              </div>
            </div>

            <div className="info-item blue">
              <Text strong data-testid="changed-title">
                Изменено
              </Text>
              <div
                style={{
                  color: 'rgb(22, 119, 255)',
                  fontWeight: '600',
                  fontSize: '24px',
                }}
                data-testid="changed-count"
              >
                {countUpdate}
              </div>
            </div>

            <div className="info-item red">
              <Text strong data-testid="skipped-title">
                Пропущено
              </Text>
              <div
                style={{
                  color: '#ff4d4f',
                  fontWeight: '600',
                  fontSize: '24px',
                }}
                data-testid="skipped-count"
              >
                {errors?.length}
              </div>
            </div>
          </div>
          {progress >= 0 && progress < 100 && (
            <Button
              className="cancel-button"
              danger
              onClick={stopImport}
              loading={isStopImportLoading}
            >
              Остановить импорт
            </Button>
          )}
          {errors?.length !== 0 ? (
            <div className="errors">
              <Text data-testid="import-complete-description">
                Исправьте ошибки и повторно загрузите файл
              </Text>
              <ul className="list">
                {errors?.map(({ row, error }, index) => (
                  <ImportErrorItem
                    key={generateKey('ImportFromExcel', 'Errors', index)}
                    row={row}
                    error={error}
                  />
                ))}
              </ul>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};
